/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ticket_claim_error_not_claimable = () => `Dieses Ticket wurde bereits personalisiert, geteilt oder zurückgegeben und kann daher nicht erneut auf einen Namen gesetzt werden. Aktualisieren Sie die Seite, um den aktuellen Stand zu sehen.`
